import React from 'react';
import { Col, Row, FormGroup } from 'react-bootstrap';
import { SetupTab } from 'areas/shared/pages/setup';
import { Label, Button } from 'fw/components';
import * as API from 'modules/app/API';
import * as App from 'modules/app/App';
import { DatePicker } from 'fw/forms';
import { MapContainer, AdminAppIdHeader } from 'areas/shared/components';
import { CertificationQueueTypeCombo, CertificationUnassignedCombo, CertificationUnassignedVoters } from 'areas/shared/controls';
import * as ReportManager from 'modules/reports/ReportManager';
import * as Notifications from 'fw/globals/Notifications';
import AdminStepToolbar from 'areas/admin/certification/shared/AdminStepToolbar';

class Assign extends SetupTab {
    initialForm() {
        return {
            places: []
        }
    }

    privileges() {
        return {
            add: App.hasPrivilege('UnassignedQueue'),
            edit: App.hasPrivilege('UnassignedQueue')
        }
    }

    urls() {
        return {
            get: API.Admin.url('/queue/getAssigneeInfo'),
            save: API.Admin.url('/queue/saveAssigneeInfo')
        }
    }

    getRequest(selectedId) {
        return {
            certificationKey: selectedId,
            QueueTypeCode: this.props.queueTypeCode
        }
    }

    isEnabled(data) {
        return !data.isReviewFinished;
    }

    saveRequest() {
        var rq = {};
        if (this.state.form.queueTypeCode === "COM")
            rq = {
                certificationId: this.state.form.certificationId,
                queueTypeCode: this.state.form.queueTypeCode,
                voters: this._voters.getSelectedVoters(),
                reviewTypeCode: "ASG"
            }
        else
            rq = {
                certificationId: this.state.form.certificationId,
                queueTypeCode: this.state.form.queueTypeCode,
                reviewerId: this.state.form.reviewerId,
                siteAssessmentScheduleDate: this.state.form.siteAssessmentScheduleDate,
                reviewTypeCode: "ASG"
            }

        return rq;
    }

    handleSiteInfoNotRequired = () => {
        this.saveSiteInfoNotRequired();
    }

    saveSiteInfoNotRequired = () => {
        var rq = {
                certificationId: this.state.form.certificationId,
                queueTypeCode: this.state.form.certificationQueueTypeCode,
                reviewerId: null,
                siteAssessmentScheduleDate: null,
            }

        API.Admin.post('/queue/saveSiteInfoNotRequired', rq, {
            success: (r) => {
                Notifications.success(r.message);

                this.setState({
                    dirty: false
                });

                if (this.props.onReviewerAssigned)
                    this.props.onReviewerAssigned();
            },
            error: r => {
                Notifications.error(r.error.errorMessage);
            }
        });
    }

    updatePostData = (form, dirty) => {
        this.setState({ form })

        if (dirty === true)
            this.dirt()
    }

    fillAddresses = (reviewwerId, auxAddress2) => {
        var auxAddress = this.state.form.vobAddress;

        var places = [];

        var vobAddress = {
            address: auxAddress && auxAddress["street1"] + "," + (auxAddress["stateCode"] || auxAddress["province"]) + "," + auxAddress["countryCode"],
            title: "1"
        };
        var reviewerAddress = {
            address: auxAddress2 && auxAddress2["street1"] + "," + (auxAddress2["stateCode"] || auxAddress2["province"]) + "," + auxAddress2["countryCode"],
            title: "2"
        };

        places.push(vobAddress);
        places.push(reviewerAddress);

        var form = this.state.form;

        form.reviewerId = reviewwerId;
        form.places = places;

        this.updatePostData(form);
    }

    handleReviewerChange = (reviewerId, reviewerAddress) => {
        if (this.state.form.queueTypeCode === "STR") {
            let rq = {
                reviewerId: reviewerId.value
            };

            API.Admin.get('/queue/getReviewerAddress', rq,
                {
                    success: (r) => {
                        this.fillAddresses(reviewerId.value, r.data.reviewerAddress);
                    }
                },
                { block: false });
        }
    }

    handleReviewerLoad = (reviewerId, reviewerAddress) => {
        if (this.state.form.queueTypeCode === "STR")
            this.fillAddresses(reviewerId, reviewerAddress);
        else {
            let form = this.state.form;

            form.reviewerId = reviewerId;

            this.updatePostData(form);
        }
    }

    handleVotersLoad = (voters) => {
        let form = this.state.form;

        form.voters = voters;

        this.updatePostData(form);
    }

    handlePrint = () => {
        const rq = Object.assign({
            reportType: "SiteReviewAssignReport",
            format: "PDF",
            parameters: {
                CertificationId: this.state.form.certificationId
            }
        });

        ReportManager.execute(rq);
    };

    renderAdminStepToolbar = () => {       
        return (
            <AdminStepToolbar
                ref={(c) => { this._ast = c }}
                onSave={this.handleSubmit}
                certificationKey={this.props.selectedId}
                reviewTypeCode={'ASSIGN'}
                queueTypeCode={this.state.form.queueTypeCode}
                showCancel={true}
                showSave={true}
                onCancel={this.handleCancel}
                disableCancel={false}
                disableSave={!this.state.dirty}
                setupProps={this.props.setupProps}
                handleTabSelect={this.props.handleTabSelect}
            />)
    }

    renderButtons = () => {
        return (
            <React.Fragment>
                <hr />
                <Row>
                    <Col md={8}>
                        {this.state.form.queueTypeCode === "STR" ?
                            <Button id="btnNotRequired" type="button" bsStyle="warning" onClick={() => this.handleSiteInfoNotRequired()}>Assessment Not Required</Button>
                        : null}
                    </Col>
                    <Col md={4}>
                        {this.renderAdminStepToolbar()}
                    </Col>
                </Row>

            </React.Fragment>
        );
    }

    renderForm() {
        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <h3 style={{ marginTop: "0px", position: "relative" }}>
                            <AdminAppIdHeader appId={this.state.form.certificationId} daysOpen={this.props.setupProps.daysOpen} certificationType={this.state.form.certificationType} certificationStatus={this.state.form.certificationStatus} />
                        </h3>
                        <hr />
                        {/* <h3>
                            {this.state.form.title}
                            <div className="pull-right"><ActionButton id="btnPrint" onClick={this.handlePrint} icon="print">Print</ActionButton></div>
                        </h3>
                        <hr /> */}
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={1}></Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label>Please, select the Review Type</Label>
                                    <CertificationQueueTypeCombo
                                        name="queueTypeCode" />
                                </FormGroup>
                            </Col>
                            <Col md={1}></Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label>Please, select the Reviewer</Label>
                                    {this.state.form.queueTypeCode !== "COM" ?
                                        <CertificationUnassignedCombo
                                            name="reviewerId"
                                            queueTypeCode={this.state.form.queueTypeCode}
                                            certificationId={this.state.form.certificationId}
                                            onLoad={this.handleReviewerLoad}
                                            onChange={this.handleReviewerChange} />
                                        : <CertificationUnassignedVoters
                                            ref={(c) => { this._voters = c; }}
                                            name="voters"
                                            certificationId={this.state.form.certificationId}
                                            onLoad={this.handleVotersLoad} />}
                                </FormGroup>
                                {this.state.form.queueTypeCode === "STR" ?
                                    <FormGroup>
                                        <p><b>Site Assessment Scheduled Date</b></p>
                                        <DatePicker
                                            ref={(c) => { this._siteAssessmentScheduleDate = c; }}
                                            className='dpThin'
                                            name='siteAssessmentScheduleDate'
                                            placeholder='Select Date'
                                            showTime={false} />
                                    </FormGroup>
                                    : null}
                            </Col>
                        </Row>
                        {this.state.form.queueTypeCode === "STR" && this.state.form.places !== undefined ?
                            <React.Fragment>
                                <Row>
                                    <Col md={1}></Col>
                                    {this.state.form.reviewerId ?
                                        <Col md={9}>
                                            {this.state.form.places && this.state.form.places.length > 1 && this.state.form.places[0].address != null && this.state.form.places[1].address != null ?
                                                <Col md={12} style={{ height: 400, marginBottom: 100, paddingLeft: 0 }}>
                                                    <h3>Locations</h3>
                                                    <MapContainer
                                                        places={this.state.form.places}
                                                    ></MapContainer>
                                                    <br />
                                                </Col>
                                            :
                                                <Col md={12} style={{ paddingLeft: 0 }}>
                                                    <h3>Locations</h3>
                                                    Addresses not found
                                                    <br />
                                                    <br />
                                                </Col>
                                            }
                                        </Col>
                                    :
                                        <Col md={9} style={{ paddingLeft: 0 }}>
                                            
                                        </Col>
                                    }
                                </Row>
                            </React.Fragment>
                        : null}
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}

export default Assign;



// WEBPACK FOOTER //
// ./src/areas/admin/certification/assign/Assign.js